const s = {
  name: "Router",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,2c-1.9,0-3.7,0.8-5,2l-1.4-1.4C25.3,1,27.5,0,30,0c2.5,0,4.7,1,6.4,2.6L35,4C33.7,2.8,31.9,2,30,2z"/>
		<path class="st0" d="M30,6c-0.8,0-1.6,0.3-2.1,0.9l-1.4-1.4C27.4,4.6,28.6,4,30,4c1.4,0,2.6,0.6,3.5,1.5l-1.4,1.4
			C31.6,6.3,30.8,6,30,6z"/>
		<path class="st0" d="M16.2,33c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,31.7,16.2,32.3,16.2,33z"
			/>
		<path class="st0" d="M20,34.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.7,33.7,19.3,34.2,20,34.2z"
			/>
		<path class="st0" d="M26.2,33c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C25.7,31.7,26.2,32.3,26.2,33z"
			/>
		<path class="st0" d="M29,9h2v17h4c2.8,0,5,2.2,5,5v4c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5v-4c0-2.8,2.2-5,5-5h24V9z M5,28
			c-1.7,0-3,1.3-3,3v4c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3v-4c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Router
};
